import { Link } from 'react-router-dom';
import bgLeft from '../assets/images/404/404_left_01.png';
import bgRight from '../assets/images/404/404_right_01.png';
import '../css/notFound.css';

export default function NotFound() {
  return (
    <div 
    className="not-found-page vh-100 d-flex flex-column justify-content-center align-items-center"
    style={{backgroundImage:`url(${bgLeft}),url(${bgRight})`}}
    >
        <div className="content">
            <div className="error-code display-1 text-danger">404</div>
            <h1 className="my-4 Galindo">¡Oops! Te has perdido en el abismo...</h1>
            <p>
                La página que buscas no existe o ha sido llevada al más allá...
            </p>
            <p>
                Recuerda que muchas páginas están bloqueadas hasta que completes los capítulos correspondientes.
            </p>
            <Link 
                to="/" 
                className="btn btn-outline-light px-4 py-2 mt-4"
            >
                Regresar al Echéndaro
            </Link>
        </div>
    </div>
  );
}